"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_SHEET_TRANSITION_DURATION = void 0;
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var helper_1 = require("../../utils/helper");
var Item_1 = tslib_1.__importDefault(require("./Item"));
var keepDom_1 = require("../../utils/keepDom");
var theme_1 = require("../../utils/theme");
var preventScrollPenetrate_1 = require("../../utils/preventScrollPenetrate");
exports.ACTION_SHEET_TRANSITION_DURATION = 200;
var ActionSheet = (function (_super) {
    tslib_1.__extends(ActionSheet, _super);
    function ActionSheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, visible = _c.visible, options = _c.options, cancelText = _c.cancelText, selectedIds = _c.selectedIds, onClickAction = _c.onClickAction, onCancel = _c.onCancel, containerStyle = _c.containerStyle, zIndex = _c.zIndex;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-hidden"] = !visible,
                _a));
            var maskClasses = classNames(prefixCls + "-mask", (_b = {},
                _b[prefixCls + "-mask-hidden"] = !visible,
                _b));
            var containerClasses = classNames(prefixCls + "-container");
            if (!keepDom_1.decideKeepDom.call(_this, exports.ACTION_SHEET_TRANSITION_DURATION, visible)) {
                return null;
            }
            return react_dom_1.default.createPortal(h(preventScrollPenetrate_1.PreventScrollPenetrateContainer, { className: containerClasses, style: tslib_1.__assign({ zIndex: zIndex }, containerStyle) },
                h("div", { className: maskClasses, onClick: onCancel }),
                h("ul", { className: classes, style: style },
                    h("div", { className: classNames(prefixCls + "-options") }, options.map(function (o) {
                        return h(Item_1.default, tslib_1.__assign({ key: o.id, selected: selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.includes(o.id), selectable: Boolean(selectedIds), onClick: onClickAction }, o));
                    })),
                    h(Item_1.default, { title: cancelText, onClick: onCancel, className: classNames(prefixCls + "-cancel") }))), document.body);
        };
        return _this;
    }
    ActionSheet.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return ActionSheet;
}(React.Component));
exports.default = ActionSheet;
ActionSheet.defaultProps = {
    prefixCls: 'dui-m-actionsheet',
    onClickAction: helper_1.emptyFn,
    onCancel: helper_1.emptyFn,
    options: [],
    cancelText: '取消',
};
ActionSheet.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    options: PropTypes.array,
    onClickAction: PropTypes.func,
    onCancel: PropTypes.func,
    visible: PropTypes.bool,
    selectedIds: PropTypes.array,
    containerStyle: PropTypes.object,
    cancelText: PropTypes.string,
    zIndex: PropTypes.number,
};
